import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-16 bg-gray-900 text-white" data-id="element-307">
      <div className="container mx-auto px-4" data-id="element-308">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 font-serif" data-id="element-309">
          THE 247ALPHA TRANSFORMATION PACKAGE
        </h2>
        <div className="w-24 h-1 bg-blue-600 mx-auto mb-12" data-id="element-310"></div>
        <div className="max-w-5xl mx-auto bg-gray-800 rounded-lg overflow-hidden shadow-xl" data-id="element-311">
          <div className="bg-blue-900 text-center py-4" data-id="element-312">
            <h3 className="text-2xl font-bold text-white" data-id="element-313">
              FOR A LIMITED TIME ONLY
            </h3>
            <p className="text-blue-300" data-id="element-314">
              Save 50% on your 30-day transformation
            </p>
          </div>
          <div className="p-8" data-id="element-315">
            <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-316">
              <div className="md:w-1/3" data-id="element-317">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha Supplement Bottle" className="w-64 h-auto mx-auto" data-id="element-318" />
              </div>
              <div className="md:w-2/3" data-id="element-319">
                <h3 className="text-2xl font-bold mb-4" data-id="element-320">
                  247Alpha 30-Day Supply
                </h3>
                <p className="mb-4" data-id="element-321">
                  Reclaim your masculine vitality with our clinically formulated
                  testosterone optimizer.
                </p>
                <div className="mb-4" data-id="element-322">
                  <div className="flex items-center justify-between mb-2" data-id="element-323">
                    <span className="text-xl" data-id="element-324">Regular Price:</span>
                    <span className="text-xl line-through text-gray-400" data-id="element-325">
                      $120
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-326">
                    <span className="text-xl font-bold" data-id="element-327">Today's Price:</span>
                    <span className="text-3xl font-bold text-blue-400" data-id="element-328">
                      $60
                    </span>
                  </div>
                  <div className="text-right text-sm text-blue-300" data-id="element-329">
                    You save: $60 (50% off)
                  </div>
                </div>
                <div className="bg-blue-800 p-2 rounded-md text-center mb-4" data-id="element-330">
                  <p className="font-bold" data-id="element-331">FREE SHIPPING on all orders</p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-700 pt-6 mb-6" data-id="element-332">
              <h4 className="text-xl font-bold mb-4" data-id="element-333">Here's What You Get:</h4>
              <div className="space-y-4 mb-8" data-id="element-334">
                <div className="flex items-start" data-id="element-335">
                  <CheckIcon className="text-blue-400 mr-3 mt-1" size={24} data-id="element-336" />
                  <div data-id="element-337">
                    <span className="font-bold" data-id="element-338">1 bottle of 247Alpha</span>{' '}
                    (30-day supply) –
                    <span className="text-blue-400" data-id="element-339"> $120 value</span>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-340">
                  <ShieldCheckIcon className="text-blue-400 mr-3 mt-1" size={24} data-id="element-341" />
                  <div data-id="element-342">
                    <span className="font-bold" data-id="element-343">100% Money-Back Guarantee</span>{' '}
                    - If you're not completely satisfied within 30 days, we'll
                    refund every penny
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-344">
              <div className="bg-blue-700 inline-block px-4 py-2 rounded-full text-white font-bold mb-4" data-id="element-345">
                Limited Time Offer - 50% OFF
              </div>
              <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="block w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-md text-xl font-bold transition duration-300 mb-4" data-id="element-346">
                ORDER NOW - ONLY $60
              </a>
              <p className="text-sm text-gray-400" data-id="element-347">
                Limited supply available. Free shipping on all orders.
              </p>
              <div className="flex justify-center mt-4 space-x-4" data-id="element-348">
                <img src="https://via.placeholder.com/60x30?text=Visa" alt="Visa" className="h-8" data-id="element-349" />
                <img src="https://via.placeholder.com/60x30?text=MC" alt="MasterCard" className="h-8" data-id="element-350" />
                <img src="https://via.placeholder.com/60x30?text=Amex" alt="American Express" className="h-8" data-id="element-351" />
                <img src="https://via.placeholder.com/60x30?text=PayPal" alt="PayPal" className="h-8" data-id="element-352" />
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-3xl mx-auto mt-8 text-center text-gray-400" data-id="element-353">
          <p data-id="element-354">
            *These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
      </div>
    </section>;
}